import { ProductLine } from 'apis/restaurant-api/merchant-admin/venue/types';
import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

export const useIsAdCampaignsEnabled = (values: {
  venueId: string;
  country?: Country | string;
  productLine?: ProductLine | string;
}) => {
  const { user } = useUser();
  const userId = user?.id || '';

  const { venueId, country, productLine } = values;

  const eligibilityCriteria = {
    user_id: userId,
    country: country ?? '',
    product_line: productLine ?? '',
    venue_id: venueId,
  };

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(['ads-merchant-campaign-rollout'], {
    ...eligibilityCriteria,
  });

  const loading = isLoading && isFetching;

  if (loading) {
    return false;
  } else {
    return featureFlags?.['ads-merchant-campaign-rollout'] === 'on';
  }
};
